module.exports = __webpack_public_path__ + "static/img/xml.52bf134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/xml.png
// module id = aRnM
// module chunks = 53